module.exports = __webpack_public_path__ + "c_static/img/recordImg.ae76c0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/recordImg.jpg
// module id = +5t3
// module chunks = 33